import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { DEFAULT_LANGUAGE } from '../../constants';
import { LangTypeMode } from '../../enums';
import type { TranslationSettings } from '../../types';
import type { TranslationSettingModel } from '../translation-settings-model';

const DEFAULT_VALUE = {
    lang: DEFAULT_LANGUAGE,
    langType: LangTypeMode.DEFAULT,
    isActivated: false,
    isVisible: false,
};

@injectable()
export class TranslationSettingModelImpl extends AbstractModel<TranslationSettings> implements TranslationSettingModel {
    protected _modelData: TranslationSettings = {
        left: { ...DEFAULT_VALUE },
        right: { ...DEFAULT_VALUE },
    };
}
